import React, { createContext, useContext, useState, useEffect } from "react";
import supabase from "../supabase"; // Assurez-vous que supabase est correctement importé

const RenovCreditsContext = createContext();

export const useRenovCredits = () => {
  return useContext(RenovCreditsContext);
};

export const RenovCreditsProvider = ({ children }) => {
  const [renovCredits, setRenovCredits] = useState(0);

  useEffect(() => {
    const fetchRenovCredits = async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (user) {
        const { data: profile } = await supabase
          .from("profiles")
          .select("renovcredits")
          .eq("id", user.id)
          .single();

        setRenovCredits(profile?.renovcredits || 0);
      }
    };

    fetchRenovCredits();

    const { subscription } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (session?.user) {
          fetchRenovCredits(); // Mettre à jour les RC lorsque l'état d'authentification change
        }
      }
    );

    return () => {
      subscription?.unsubscribe();
    };
  }, []);

  return (
    <RenovCreditsContext.Provider value={{ renovCredits, setRenovCredits }}>
      {children}
    </RenovCreditsContext.Provider>
  );
};
